module.exports = __webpack_public_path__ + "img/54C104_BBFA0F_97EF04_7AE104-256px.b8b24acc.png";